// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                                           from 'firebase/functions';

// ===== Interfaces =====

import {
    ICartItem,
    IMailingListSubscriptionValue,
    IAnnotationCommentSubscriptionValue,
    IReaderChapterProgressItem,
}                                           from '../interfaces';

// ===== Enums =====

import {
    ZOOM_LEVEL,
}                                           from '../components/Editor/elements/enums';

const updateUser = async ({
    test,
    email,
    avatarFilePath,
    firstName,
    lastName,
    phoneNumber,
    photoURL,
    sessionsToAdd,
    zoom,
    mailingListSubscriptionToAdd,
    commentSubscriptionToAdd,
    hideAnnotations,
    customCursorEnabled,
    saveReaderProgress,
    readerChapterProgressToSet,
    cart,
    cartToEmpty,
}: {
    test: boolean,
    email?: string,
    avatarFilePath?: string,
    firstName?: string,
    lastName?: string,
    phoneNumber?: string,
    photoURL?: string,
    sessionsToAdd?: string[],
    zoom?: ZOOM_LEVEL,
    mailingListSubscriptionToAdd?: IMailingListSubscriptionValue[],
    commentSubscriptionToAdd?: IAnnotationCommentSubscriptionValue[],
    hideAnnotations?: boolean,
    customCursorEnabled?: boolean,
    saveReaderProgress?: boolean,
    readerChapterProgressToSet?: IReaderChapterProgressItem,
    cart?: ICartItem[],
    cartToEmpty?: boolean,
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleUpdateUser = httpsCallable<
        Record<
            string,
            // eslint-disable-next-line max-len
            boolean | string | string[] | ZOOM_LEVEL | IMailingListSubscriptionValue[] | IAnnotationCommentSubscriptionValue[] | IReaderChapterProgressItem | ICartItem[] | undefined
        >,
        boolean
    >(
        functions,
        'updateUser',
    );
    return handleUpdateUser({
        test,
        email,
        avatarFilePath,
        firstName,
        lastName,
        phoneNumber,
        photoURL,
        sessionsToAdd,
        zoom,
        mailingListSubscriptionToAdd,
        commentSubscriptionToAdd,
        hideAnnotations,
        customCursorEnabled,
        saveReaderProgress,
        readerChapterProgressToSet,
        cart,
        cartToEmpty,
    }).then((result) => {
        const success = result.data as boolean;
        return success;
    }).catch((err) => {
        throw err;
    });
};

export default updateUser;
